<div class="flex-container">
  <ng-container  *ngIf="isCrack == 1" >
  <div class="panel__content no-padding">
      <table class="table table--striped table--full-width">
          <thead>
              <tr style="text-align-last: center;">
                  <th class="right-align schematicName">{{schematicDetails.Name}}
                  <!-- <mat-icon  style="margin-left: 14px; cursor: pointer;" title="Add Observation Point or Crack"
                  (click)="openSchematicWindow(schematicDetails)">add_location_alt</mat-icon></th> -->
              </tr>
          </thead>
          <tbody>
              <tr>
                  <td>
                      <app-schematic-observation-points [SchematicOP]="ObservationPointDetails" [schematicData]="schematicDetails" [isCrack]="1" style="position: relative;" ></app-schematic-observation-points>
                    
                  </td>
              </tr>
          </tbody>
      </table>
  </div>
  <div class="panel__content no-padding">
      <!-- Asset Details -->
    
      <table class="table table--striped table--full-width" >

          <thead>
              <tr>
                  <th style="padding: 16px 45px;text-align: left;">Component</th>
                  <th style="padding: 16px 24px;text-align: left;">Observation Point</th>
                  <th style="text-align: center; padding: 16px 24px;text-align: center;">OP Type</th>
                  <th style="text-align: center; padding: 16px 24px;text-align: center;">% Worn</th>

                  <ng-container *ngIf="headerAction!=null">
                    <ng-container *ngFor="let item of headerAction.ObsActionHistroyDFI">
                        <th style="padding: 16px 24px;text-align: left;">
                          <div style="display: flex;flex-direction: column;text-align: center;">
                            <!-- <span  *ngIf="item.isComponentAction==1"  style="cursor: pointer;" class="material-icons" (click)="OpenReplaceRepairAction(item)">
                                build_circle
                                </span>
                              <span> {{item.Action}}</span> -->
                              <span> {{item.ActionDate|date: 'dd MMM yyyy'}} </span>
                          </div>
                      </th>
                    </ng-container>
                  </ng-container>
                 
              </tr>
          </thead>
          <tbody>
              <ng-container *ngFor="let OP of ObservationPointDetails">
                  <tr >
                      <td  (click)="OpenNormalObsHistroyDialog(OP)"style="cursor: pointer;"class=" columncell" title="{{OP.ComponentName}}">{{OP.ComponentName}}</td>
                      <td (click)="OpenNormalObsHistroyDialog(OP)" style="cursor: pointer;" class=" columncell" title="{{OP.Name}}">{{OP.Name}}</td>
                      <td   style="cursor: pointer;" class="columncell" *ngIf="OP.Type == 'Crack'" title="{{OP.ObsQuestion}}" >
                          <ng-container >
                              <div class="{{getCrackStatus(OP.IsCrackFixed)}}">
                                  {{OP.Type}}
                              </div>
                          </ng-container>
                      
                      </td>
                      <td (click)="OpenNormalObsHistroyDialog(OP)" style="cursor: pointer;" class="columncell" *ngIf="OP.Type != 'Crack'" title="{{OP.ObsQuestion}}"> {{OP.Type}}</td>
                      <!-- <td (click)="OpenNormalObsHistroyDialog(OP)" style="cursor: pointer;">
                          <ng-container *ngIf="OP.Eval == ''">
                              <div class="{{getEvalClass(OP.WornPct)}}">
                                  {{OP.WornPct}}%
                              </div>
                          </ng-container>
                          <ng-container *ngIf="OP.Eval != ''">
                              <div class="{{getEvalClass2(OP.Eval)}}">
                                  {{OP.Eval}}
                              </div>
                          </ng-container>
                      </td> -->

                      <td (click)="OpenNormalObsHistroyDialog(OP)" style="cursor: pointer;">
                        <ng-container *ngIf="OP.Eval == ''">
                            <div class="{{getEvalClass(OP.WornPct)}}">
                                {{OP.WornPct}}%
                            </div>
                        </ng-container>

                        <ng-container *ngIf="OP.Eval != '' && OP.ObPointTypeId==3">
                            <div class="{{getEvalClass2(OP.Eval)}}">
                              {{OP.Eval}}
                            </div>
                        </ng-container>
                        <ng-container *ngIf="OP.Eval != '' && OP.ObPointTypeId==4">
                            <div class="{{getEvalClass2('U')}}">
                                {{OP.Eval}}
                            </div>
                        </ng-container>
                    </td>
                      <ng-container *ngIf="OP.ObsActionHistroyDFI!=null">
                        <ng-container *ngFor="let item of OP.ObsActionHistroyDFI">
                            <td  style="cursor: pointer;">
                                <ng-container *ngIf="OP.Eval == ''">
                                    <div *ngIf="item.WornPercent!=null" class="{{getEvalClass(item.WornPercent)}}">
                                        {{item.WornPercent}}%
                                    </div>
                                    <div *ngIf="item.WornPercent==null" class="WornPctCell noEval">
                                        N/A
                                    </div>
                                </ng-container>
                                <ng-container *ngIf="OP.Eval != ''">
                                    <div class="{{getEvalClass2(item.Eval)}}">
                                        {{item.Eval}}
                                    </div>
                                </ng-container>
                            </td>
                            <!-- <td style="cursor: pointer;text-align: center;" *ngIf="item.isComponentAction!=0">
                                <ng-container *ngIf="OP.ComponentId == item.CompId">
                                    <span class="material-icons">
                                        build_circle
                                        </span>
                                </ng-container>
                            </td> -->
                        </ng-container>
                    </ng-container>

                                                                                 
                  </tr>
              </ng-container>
          </tbody>
      </table>
  
  <!-- end Asset Details -->


  </div>
</ng-container>

</div>